import { gql } from 'graphql.macro';

export const saveLabAppBannerSettingsTemplate = gql`
    mutation saveLabAppBannerSettings($_id: MongoDbObjectId!, $labAppBannerSetting: AppBannerSettingInput!) {
        saveLabAppBannerSettings(_id: $_id, labAppBannerSetting: $labAppBannerSetting)
    }
`;

export const saveClinicAppBannerSettingsTemplate = gql`
    mutation saveClinicAppBannerSettings($_id: MongoDbObjectId!, $clinicAppBannerSetting: AppBannerSettingInput!) {
        saveClinicAppBannerSettings(_id: $_id, clinicAppBannerSetting: $clinicAppBannerSetting)
    }
`;

export const saveAuthAppBannerSettingsTemplate = gql`
    mutation saveAuthAppBannerSettings($_id: MongoDbObjectId!, $authAppBannerSetting: AppBannerSettingInput!) {
        saveAuthAppBannerSettings(_id: $_id, authAppBannerSetting: $authAppBannerSetting)
    }
`;
